import { HeaderWrapper } from 'layouts';
import type { OrganizationDetail } from 'models';
import { useTranslation } from 'react-i18next';
import { hasMembershipInOrganizationProfile } from 'permissions';
import { HeaderAsset, HeaderContent } from 'ui';
import { useUser } from 'features/auth';
import { OrganizationStatus } from '../components';
import { useGetOrganizationIcon, useGetOrganizationTag } from '../hooks';

type P = {
  organization: OrganizationDetail;
};

const OrganizationDetailHeader = ({ organization }: P) => {
  const { t } = useTranslation();
  const getOrganizationTag = useGetOrganizationTag();
  const getOrganizationIcon = useGetOrganizationIcon();
  const { railsUserData: viewer } = useUser();

  const isJoined = hasMembershipInOrganizationProfile({ organizationId: organization.id, viewer });

  return (
    <HeaderWrapper
      left={<HeaderAsset image={{ alt: t('Organization cover photo'), src: organization.coverPhoto?.url }} />}
      right={
        <HeaderContent
          extra={isJoined ? <OrganizationStatus /> : null}
          membersCount={organization.membersCount}
          tags={{
            children: getOrganizationTag({ organization }),
            icon: getOrganizationIcon({ organization }),
          }}
          title={organization.name}
        />
      }
    />
  );
};

export default OrganizationDetailHeader;
